import React, { Component } from 'react';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';

// Material Icons Imports
import IconSpa from '@material-ui/icons/Spa';
import IconPerson from '@material-ui/icons/Person';
import IconFileFolder from '@material-ui/icons/Folder';

import { withStyles } from '@material-ui/core/styles';

import pink from '@material-ui/core/colors/pink';
import orange from '@material-ui/core/colors/orange';
import { ListItemText } from '@material-ui/core';

const orange200 = orange['200'];
const pink400 = pink['400'];
const styles = {
  avatar: {
    width: 30,
    height: 30,
    color: orange200,
    backgroundColor: pink400
  },
  listItemTextPrimary: {
    color: "rgba(0, 0, 0, 0.3)",
    fontSize: "14px",

  }
};

class AvatarItem extends Component {
  render() {
    let avatarIcon = null;
    let label = null;
    let dateLabel = null;
    const { classes } = this.props;
    let disabled = false;
    let chip = <Chip label="Inactive" />;

    switch (this.props.type) {
      case "user":
        avatarIcon = <IconPerson />;
        disabled = !this.props.object.active;
        label = this.props.object.fullName;
        break;
      case "customDateUser":
        const date = "Since: " +
          new Date(
            Date.parse(this.props.object.inserted_at)
          ).toLocaleTimeString() +
          " - " +
          new Date(
            Date.parse(this.props.object.inserted_at)
          ).toLocaleDateString();
        avatarIcon = <IconPerson />;
        disabled = !this.props.object.user.active;
        label = this.props.object.user.fullName;
        dateLabel = date;
        break;
      case "enclosure":
        avatarIcon = <IconFileFolder />;
        label = this.props.object.name;
        break;
      case "Title":
      default:
        label = "Label for Avatar";
        avatarIcon = <IconSpa />;
    }

    return (
      <ListItem disabled={disabled}>
        <Avatar className={classes.avatar}>{avatarIcon}</Avatar>
        <ListItemText primary={label} />
        <ListItemText
          classes={{
            primary: classes.listItemTextPrimary
          }}
          primary={dateLabel ? dateLabel : null}
        />
        {disabled && chip}
      </ListItem>
);
  }
}

export default withStyles(styles)(AvatarItem);



// WEBPACK FOOTER //
// src/components/innerComponents/AvatarItem.js